import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { AudioBar, AuthorInfoCard } from "..";
import { API_PATHS } from "../../../API/api_paths";
import { FlexColumnSpaced } from "../Styles";
import AudioPlayerProps from "./AudioPlayer";
import { useRef } from "react";
import { useContainerSize } from "../../../hooks/useContainerSize";

export const AudioPlayer = (props: AudioPlayerProps.IProps) => {
  const {
    audio_title,
    audio_description,
    id,
    audioBackgroundImage,
    isViewOnly,
    selectedCollaborator,
  } = props;
  const ref = useRef(null);
  const { width } = useContainerSize(ref);
  const isImageSelected = audioBackgroundImage.background_type === "image";
  const selectedGradient = isImageSelected
    ? audioBackgroundImage.background_value
    : JSON.parse(audioBackgroundImage.background_value);

  const background = isImageSelected
    ? "linear-gradient(90deg, rgba(0, 0, 0, 0.60) 0%, rgba(256, 256, 256, 0.20) 100%)"
    : `linear-gradient(${selectedGradient.rotation}deg, ${selectedGradient.color_1} 0%, ${selectedGradient.color_2} 100%)`;

  return (
    <Container
      $width={width}
      $background={
        isImageSelected
          ? `url(${
              process.env.REACT_APP_GORRILA_API +
              "/images/posts/" +
              audioBackgroundImage.image_id
            }) lightgray 50% / cover no-repeat`
          : background
      }
      ref={ref}
    >
      <AudioContainer $isSingleAuthor={selectedCollaborator.length === 1}>
        {selectedCollaborator.length > 0 ? (
          <AuthorInfoCard
            mode={"ColourAdapt"}
            backgroundColor={background}
            authorData={selectedCollaborator}
          />
        ) : (
          <div />
        )}
        <AudioBar
          backgroundColor={background}
          title={audio_title}
          description={audio_description}
          url={API_PATHS.postAudio.getPostAudio + id}
          isViewOnly={isViewOnly}
        />
      </AudioContainer>
    </Container>
  );
};

const Container = styled.div<{ $background: string; $width: number }>`
  background: ${({ $background }) => $background};
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  position: relative;
  height: ${({ $width }) => ThisGorillaUtils.convertPxToRem(String($width))}rem;
  width: 100%;
`;

const AudioContainer = styled(FlexColumnSpaced)<{ $isSingleAuthor: boolean }>`
  position: absolute;
  inset: 0;
  align-items: ${({ $isSingleAuthor }) => ($isSingleAuthor ? "center" : "end")};
  padding: ${({ theme }) => theme.spacing["spacing-6"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
